import React, { Component } from 'react';
import './ErrorBoundry.css';

class ErrorBoundry extends Component{
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        }
    }

    componentDidCatch(error, info) {
        this.setState({hasError: true})
    }
    
    render() {
        if(this.state.hasError){
            return <h1 className='text-center'>Something went wrong, try again!</h1>
        }else{
            return this.props.children
        }
    }
}

export default ErrorBoundry;